export default __webpack_public_path__ + "static/B0078-da7f6071069f296f2c3f6ed761baefc9.png";